<div class="dialog-header">
  <div class="header-title">
    <span class="header-span">
      <ng-container *ngIf="newMisc">New Misc Item</ng-container>
      <ng-container *ngIf="!newMisc">{{misc.name}}</ng-container>
    </span>
  </div>

  <button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()" [tabindex]="-1">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="middle-content">
  <div class="inputs-block">
    <ng-container *ngIf="newMisc">

      <div class="input-block">
        <div class="input-label">Name:</div>

        <div class="email-input-text">
          <input #miscName class="arrow-input misc-name-input" type="text" pInputText BlockLateralArrowNavigation
                 tabindex="1"
                 [ngModelOptions]="{standalone: true}" [(ngModel)]="misc.name">
        </div>
      </div>
      <div class="input-block" *ngIf="!misc.forThisProjectOnly">
        <div class="input-label">Group:</div>

        <div class="email-input-text">
          <p-dropdown [options]="miscGroups" [(ngModel)]="miscGroup" class="group-dropdown"
                      placeholder="Group"
                      optionLabel="name" appendTo="body" panelStyleClass="p-misc-dropdown-panel"
          ></p-dropdown>
        </div>
      </div>
      <div class="input-block">
        <div class="input-label">Price:</div>

        <div class="email-input-text">
          <input class="arrow-input" type="number" pInputText BlockLateralArrowNavigation
                 [ngModelOptions]="{standalone: true}" [(ngModel)]="misc.pricePerItem">
        </div>
      </div>
      <div class="input-block">
        <div class="input-label">Ins. Price:</div>

        <div class="email-input-text">
          <input class="arrow-input" type="number" pInputText BlockLateralArrowNavigation
                 [ngModelOptions]="{standalone: true}" [(ngModel)]="misc.pricePerItemInstall">
        </div>
      </div>
      <div class="input-block">
        <div class="input-label">Description:</div>

        <div class="email-input-text">
          <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation
                 [ngModelOptions]="{standalone: true}" [(ngModel)]="misc.description">
        </div>
      </div>
      <div class="input-block">

        <div class="email-input-text">
          <p-checkbox [(ngModel)]="misc.forThisProjectOnly" [binary]="true"
                      label="Create For This Project Only">
          </p-checkbox>
        </div>
      </div>
    </ng-container>
    <div class="input-block">
      <div class="input-label">Files:</div>

      <div class="email-input-text" *ngIf="filesLoading">
        <lib-progress-spinner></lib-progress-spinner>
      </div>
      <div class="email-input-text" *ngIf="!filesLoading">
        <div class="file-names">
          <div class="file" *ngFor="let miscFile of miscFiles; let i = index" [ngClass]="{'picture-file-block': miscFile.ext ==='jpg' || miscFile.ext ==='jpeg' ||
		miscFile.ext==='png' || miscFile.ext==='gif' || miscFile.ext==='webp'}">
            <div class="file-icon"
                 *ngIf="miscFile.ext !== 'jpg' && miscFile.ext !== 'jpeg' && miscFile.ext !== 'png' && miscFile.ext !== 'gif' && miscFile.ext !== 'webp'">
              <mat-icon class="material-icons-outlined md-18">{{getIcon(miscFile.ext)}}</mat-icon>
            </div>
            <div class="file-thumbnail"
                 *ngIf="miscFile.ext === 'jpg' || miscFile.ext === 'jpeg' || miscFile.ext === 'png' || miscFile.ext === 'gif' || miscFile.ext === 'webp'"
                 (click)="openFile(miscFile)">
              <img [src]="getTinyIcon(miscFile.id)">
            </div>
            <div class="file-block"
                 [ngClass]="{'tablet-files': !isDesktop, 'mobile-files': isMobile, 'clickable-files': misc.id }">
              <div class="file-name">
                <span (click)="openFile(miscFile)">{{miscFile?.name}}</span>
              </div>
              <div class="fila-infa">
                <div class="file-info">
                  {{miscFile.user?.username}},
                </div>

                <div class="file-info">
                  {{miscFile.uploadTime | date: 'MMM dd, yyyy'}}
                </div>
              </div>

            </div>

            <span class="delete-icon" (click)="deleteFile(miscFile, i)">
              <mat-icon>clear</mat-icon>
            </span>
          </div>
        </div>
        <span *ngIf="miscFiles?.length === 0">No Files</span>
      </div>
    </div>
    <mat-progress-bar *ngIf="progressBar > 0" mode="determinate" value="{{progressBar}}">
    </mat-progress-bar>

    <span class="file-upload-text">You can attach screenshots and files from clipboard.</span>

    <p-fileUpload mode="basic" name="files" #filesForm (onProgress)="onProgress($event)" [customUpload]="true"
                  (uploadHandler)="uploadFile($event.files, filesForm)" [auto]="true" [multiple]="true"
                  chooseLabel="Attach" *ngIf="!filesLoading">
    </p-fileUpload>
  </div>

  <div class="save-btn-block" *ngIf="newMisc">
    <div class="sav-btn-bloock">

      <button mat-button class="save-btn" (click)="saveMiscItem()"
              [disabled]="saveLoading || !misc.name"
              type="submit"
              [ngClass]="{'disabled-button': saveLoading || !misc.name}">

        <span *ngIf="!saveLoading">Create</span>
        <lib-mini-progress-spinner *ngIf="saveLoading"></lib-mini-progress-spinner>
      </button>

    </div>
  </div>
</div>
